<template>
  <b-container class="corpo">
    <b-form @submit="onSubmit">
      <b-row>
        <b-col sm="3" offset-sm="2">
          <div class="titulo">
            <h4>Adicionar Palestra</h4>
          </div>
        </b-col>
        <b-col sm="8"></b-col>
      </b-row>
      <b-row>
        <b-col sm="3" offset-sm="1">
          <div class="adicionar-imagem">
            <div id="preview">
              <img v-if="url" :src="url" />
            </div>
            <div class="upload-btn-wrapper">
              <button type="button" class="btnImg" @click="onClickAddImg">
                Adicionar Imagem
              </button>

              <input
                class="invisible"
                ref="inputImg"
                type="file"
                name="foto"
                @change="onFileChange"
              />
            </div>
          </div>
        </b-col>

        <b-col sm="8">
          <div class="input-forms">
            <!-- inicio do input titulo -->
            <b-form-group
              id="input-group-titulo"
              label="Título da palestra"
              label-for="input-titulo"
            >
              <b-form-input
                id="input-titulo"
                v-model="form.title"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
            <!-- fim do input titulo -->

            <!-- inicio do input descricao -->
            <b-form-group
              id="input-group-descricao"
              label="Descrição"
              label-for="input-descricao"
            >
              <b-form-textarea
                id="input-descricao"
                v-model="form.description"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
            <!-- fim do input descricao -->

            <div class="form-row">
              <!-- inicio do input data -->
              <div class="form-group col-md-3">
                <label for="datepicker-dateformat2">Data</label>
                <b-form-datepicker
                  inline
                  id="datepicker-dateformat2"
                  v-model="form.date"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  locale="br"
                  placeholder
                ></b-form-datepicker>
              </div>
              <!-- fim do input data -->

              <div class="form-group col-md-3">
                <!-- inicio do input horario -->
                <label for="timepicker">Hora início</label>
                <b-form-timepicker
                  inline
                  id="timepicker-sm"
                  v-model="form.hour"
                  local="br"
                  class="mb-2"
                  placeholder
                  hide-header="true"
                  label-close-button="Fechar"
                ></b-form-timepicker>
                <!-- fim do input horario -->
              </div>

              <div class="form-group col-md-3">
                <!-- inicio do input horario -->
                <label for="timepicker">Hora fim</label>
                <b-form-timepicker
                  inline
                  id="timepicker-sm-2"
                  v-model="form.hourEnding"
                  local="br"
                  class="mb-2"
                  placeholder
                  hide-header="true"
                  label-close-button="Fechar"
                ></b-form-timepicker>
                <!-- fim do input horario -->
              </div>
            </div>

            <!-- inicio url da palestra -->
            <b-form-group
              id="url-palestra"
              label="URL da palestra"
              label-for="url"
            >
              <b-form-input
                id="url"
                v-model="form.ytURL"
                required
              ></b-form-input>
            </b-form-group>
            <!-- fim url da palestra -->

            <!-- inicio selecao palestrante -->
            <b-form-group
              id="input-group-3"
              label="Palestrante:"
              label-for="input-3"
            >
              <b-form-select
                id="input-3"
                v-model="form.speaker"
                :options="palestrantes"
                required
              ></b-form-select>
            </b-form-group>
            <!-- fim selecao palestrante -->
          </div>
        </b-col>
      </b-row>
      <div id="botaoSalvar">
        <b-button
          class="botaoSalvar"
          :disabled="!form.photo"
          type="submit"
          variant="primary"
          >Salvar</b-button
        >
      </div>
    </b-form>
  </b-container>
</template>

<style scoped>
.corpo {
  padding-top: 5%;
}

.titulo {
  margin-bottom: 20%;
  letter-spacing: 0px;
  color: #202020;
}

/* estilo imagem */

.adicionar-imagem {
  text-align: right;
}

#preview {
  margin-top: 20px;
  /* max-height: 150px;
    max-width: 150px; */
  /* margin-bottom: 15%; */
}

img {
  border-radius: 5%;
  height: 150px;
  width: 150px;
  margin-bottom: 3%;
  object-fit: cover;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.upload-btn-wrapper input[type="file"] {
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0;
}

.btnImg {
  color: black;
  background: transparent;
  height: 28px;
  width: 125px;
  border: 1px solid black;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  margin-right: 12.5px;
}

.invisible {
  display: none;
}

/* fim estilo imagem */

.input-forms {
  margin-top: -20px;
}

#botaoSalvar {
  margin-top: 2%;
  text-align: center;
}

.botaoSalvar {
  color: #fff;
  background: #5928c2;
  border-radius: 0px;
  border: none;
  width: 150px;
  font-weight: 500;
  cursor: pointer;
  z-index: 99;
}

.form-control {
  border: 1px solid black;
  border-radius: 0px;
  font-family: roboto;
  width: 70%;
  margin-top: -5px;
}

.b-form-btn-label-control {
  width: 160px;
  border: 1px solid black;
  border-radius: 0px;
  font-family: roboto;
  margin-top: -5px;
}

select {
  border: 1px solid black;
  border-radius: 0px;
  font-family: roboto;
  width: 70%;
  margin-top: -5px;
}

input {
  margin-top: -5px;
  width: 70%;
  height: 32px;
  border: 1px solid #ee3824;
  border-radius: 4px;
  font-family: roboto;
  margin-top: -5px;
}

input:focus {
  border: 0px solid #ee3824;
}
</style>

<script>
import { listarPalestrantes } from "@/services/api/Palestrantes";
import { baseUrl } from "@/config/constants";
import {
  novaPalestra,
  palestraById,
  updatePalestra,
} from "@/services/api/Palestra";

export default {
  beforeCreate() {
    listarPalestrantes()
      .then((res) => {
        const data = res.data.map((palestrante) => {
          return { value: palestrante._id, text: palestrante.name };
        });
        this.palestrantes = [
          { text: "Escolher", disabled: true, value: null },
          ...data,
        ];
      })
      .catch((error) => {
        console.error("Erro ao obter palestrantes", error.response);
      });
  },
  data() {
    return {
      url: "https://picsum.photos/id/1005/600/200",
      form: {
        title: "",
        description: "",
        speaker: null,
        ytURL: "",
        date: "",
        hour: "",
        hourEnding: "",
        photo: undefined,
      },
      palestrantes: [],
      show: true,
      idPalestra: undefined,
    };
  },
  created() {
    if (this.$route.params.idPalestra) {
      this.idPalestra = this.$route.params.idPalestra;
      palestraById(this.idPalestra).then((res) => {
        this.form = res.data;
        this.form.speaker = this.form.speaker._id;
        this.url = baseUrl + this.form.photo;
      });
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      if (this.idPalestra) {
        updatePalestra(this.form)
          .then(() => {
            this.$router.push("/admin/palestras");
          })
          .catch((error) => {
            console.error("erro ao atualizar palestra", error.response);
          });
      } else {
        novaPalestra(this.form)
          .then(() => {
            this.$router.push("/admin/palestras");
          })
          .catch((error) => {
            console.error("erro ao salvar palestra", error.response);
          });
      }
    },
    onClickAddImg() {
      this.$refs.inputImg.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      this.form.photo = file;
    },
  },
};
</script>
